import React from 'react';
import MomentUtils from "@date-io/moment";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {Input} from './input/Base';
import { Util } from '../common';
import { DatePicker, DateTimePicker,MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from 'moment';
import 'moment/locale/zh-cn';
import { FormControl, InputLabel, FormHelperText, IconButton } from '@material-ui/core';
import EventIcon from '@material-ui/icons/Event';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';


const useStyles = makeStyles(theme => ({
    root: {
      padding:2,
      margin:0
    },
  }));

  export default function _IconButton(props) {
    const classes = useStyles();
  
    return (
      <IconButton className={classes.root} {...props} />
    );
  }

moment.locale("zh-cn");

export class DateTime extends Input {
   
    constructor(props) {
        super(props);
        this.state={
            ...this.state,
            value:null
        }
    }

    get() {
        return this.value;
    }

    set(v) {
        if (Util.type(v) == "string") v = new Date(v);
        this.value = v;
        this.setState({value:v});
    }

    reset() {
        super.reset();
        this.set(null);
    }

    _handleChange(e){
        let value = e?e.toDate():null;
        this.handleChange(value);
    }

    validate(){
        var e = super.validate();
        if(e) return e;
    }

    onBlur(e){
        let {onBlur} = this.props;
        this.validate();
        if(onBlur)onBlur(e);
    }

    clear(){
        this.reset();
        this._handleChange(null);
    }

    renderDate(){
        let {label,placeholder,required,variant} = this.props;
        let {value,error}=this.state;
        return (
            <DatePicker
                disabled={this.disabled()}
                required={required}
                placeholder={placeholder}
                inputVariant={variant}
                label={label}
                showTodayButton={true}
                todayLabel="今天"
                okLabel="确定"
                cancelLabel="取消"
                error={error?true:false}
                helperText={error||this.help()}
                format="YYYY/MM/DD"
                fullWidth
                value={value}
                onChange={this._handleChange.bind(this)}
                animateYearScrolling={false}
                InputLabelProps={{
                    shrink: true
                }}
                InputProps={{
                    endAdornment: (
                        value?
                        <_IconButton onClick={(e)=>{ this.clear(); e.stopPropagation(); }}>
                        <HighlightOffIcon />
                        </_IconButton>:<EventIcon style={{color :"rgba(0, 0, 0, 0.54)",marginRight:5}} />
                        ),
                    }}
            />
        );
    }

    renderDateTime(){

        let {label,placeholder,required,variant,future} = this.props;
        let {value,error}=this.state;
        return (
            <DateTimePicker
                disabled={this.disabled()}
                required={required}
                placeholder={placeholder}
                inputVariant={variant}
                label={label}
                showTodayButton={true}
                todayLabel="今天"
                okLabel="确定"
                cancelLabel="取消"
                error={error?true:false}
                helperText={error||this.help()}

                ampm={false}
                disableFuture={future}
                format="YYYY/MM/DD HH:mm"

                fullWidth
                value={value}
                onChange={this._handleChange.bind(this)}
                animateYearScrolling={false}
                InputLabelProps={{
                    shrink: true
                }}
                InputProps={{
                    endAdornment: (
                        value?
                        <_IconButton onClick={(e)=>{ this.reset(); e.stopPropagation(); }}>
                        <HighlightOffIcon />
                        </_IconButton>:<EventIcon style={{color :"rgba(0, 0, 0, 0.54)",marginRight:5}} />
                        ),
                    }}
            />
        );
    }

    renderMain(){
        let {mode} = this.props;
        if(mode === "date") return this.renderDate();
        if(mode === "dateTime") return this.renderDateTime();
    }

    render() {
        let {width, minWidth, maxWidth} = this.props;
        let {error}=this.state;
        let style = { width, minWidth, maxWidth };
        return (
            <FormControl style={style} className={this.getClassName(`c-date ${error?"c-error":""} ${width ||minWidth || maxWidth? '' : 'w-100'}`)} error={error?true:false} disabled={this.getDisabled()} >
                {this.tipComponent("dateTime",{ignore:true})}
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={"zh-cn"}>
                    {this.renderMain()}
                </MuiPickersUtilsProvider>
            </FormControl>
        )
    }
  }
  
  DateTime.defaultProps = {
    size:"medium",
    mode:"date",
    variant:"outlined", //"standard",
  }